module.exports = __webpack_public_path__ + "img/weight_two.33e1d220.png";